export enum Direction {
  NEXT = -1,
  BACK = -2,
  NEUTRAL = -3,
}
